export const GET_SALE_PRICES_REQUEST = "GET_SALE_PRICES_REQUEST";
export const GET_SALE_PRICES_SUCCESS = "GET_SALE_PRICES_SUCCESS";
export const GET_SALE_PRICES_FAILURE = "GET_SALE_PRICES_FAILURE";
